<form [formGroup]="tableForm" (ngSubmit)="submitTableNumber()">
  <div class="form-group">
    <!-- <label for="table-number" class="auth-label">Table number</label> -->
    <!-- <input
      type="number"
      class="auth-input"
      formControlName="tableNumber"
      id="table-number"
      aria-label="input for table number"
    /> -->
    <ng-select formControlName="tableNumber">
      <ng-option
        *ngFor="let table of allTables"
        class="primary-font-normal"
        [value]="table?.id"
      >
        {{ table?.name }}
      </ng-option>
    </ng-select>
  </div>

  <div class="mt-48">
    <button
      [disabled]="tableForm.invalid"
      class="btn btn-block btn-table-number f-14 primary-font-normal"
    >
      {{ buttonText }}
    </button>
  </div>
</form>
